const errorImage = (event: HTMLImageElement) => {
    event.src = process.env.REACT_APP_ERROR_IMG_URL!;
}

export default errorImage;